import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import BackLink from '../shared/BackLink';
import { Header, PrimaryButton, SecondaryButton } from '../v3Styles';
import { BlueSubHeader, ButtonRow, Wrapper } from './yearbookStyles';

const CompleteWrapper = styled.div`
  margin: 57px 0;
  width: 929px;
  max-width: 90%;
`;

const SelectYearbookComplete = ({ history }) => {
  const handleContinueClick = () => {
    // TODO: If we want to redirect to incentive offers from here
    // we need to adjust product flows to set `allAvailablePoses`
    // on load if not set. Currently, only the goToOrder method in the dashboard
    // sets this, so if we follow any other route to a product
    // page, it's possible this isn't set, causing js errors - blank screen.
    //history.push('/v3/incentive-offers');
    history.push('/dashboard');
  };

  const handleReturnClick = () => {
    history.push('/dashboard');
  };

  return (
    <Wrapper>
      <BackLink history={history} />
      <CompleteWrapper>
        <Header>Thank you for selecting your yearbook pose!</Header>
        <BlueSubHeader>
          Would you like to purchase any of your yearbook photos?
        </BlueSubHeader>
      </CompleteWrapper>
      <ButtonRow>
        <SecondaryButton onClick={handleReturnClick}>
          Return to My Galleries
        </SecondaryButton>
        <PrimaryButton onClick={handleContinueClick}>
          Yes, continue
        </PrimaryButton>
      </ButtonRow>
    </Wrapper>
  );
};

SelectYearbookComplete.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    block: PropTypes.func.isRequired,
  }).isRequired,
};

export default SelectYearbookComplete;
